import { render } from "./Unauthorized.vue?vue&type=template&id=4f82dae9"
const script = {}

import exportComponent from "E:\\dipto_projects\\asset_tracker\\aqc-asset-tracker-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__